import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";

/** One sign-in entry point; provider selection stays on the account page. */
export default function GoogleSignUpButton({ className = "" }: { className?: string }) {
  const { user } = useAuth();
  if (user) return null;

  return (
    <Button variant="ghost" size="sm" asChild className={`min-h-11 rounded-full ${className}`}>
      <Link to="/auth?mode=signin">Sign in</Link>
    </Button>
  );
}
